module.exports = function() {
  return new Worker(__webpack_public_path__ + "b96812a931b6d934c899.worker.js");
};